module.exports = __webpack_public_path__ + "img/accredition.1a6be094.png";